<script lang="ts">
    import type { ReminderMemoryManagerSettings } from "@utils/practice/reminder-memory-manager"
    import TimeSliderDraggable from "./time-slider-draggable.svelte"
    import type { LessonTime } from "@utils/practice/reminder-time-conversion"
    import { addMinutes, format, startOfDay } from "date-fns"
    import type { MinutesAfterMidnight } from "@utils/practice/day-time"

    export let classList = ""
    export let reactiveMemoryManager : ReminderMemoryManagerSettings
    export let practice: LessonTime
    export let duration = 0
    export let pulseBefore : MinutesAfterMidnight
    export let hidden : boolean
    export let enabled: boolean
    export let grayscale : boolean
    export let lowerLimit: MinutesAfterMidnight
    export let upperLimit: MinutesAfterMidnight
    export let minuteToPercent: (min: MinutesAfterMidnight) => number
    export let percentToMinute: (percent: number) => MinutesAfterMidnight
    function changeIndividualPosition(index: number, percent: number) {
        reactiveMemoryManager.updateTimeLesson(practice, index, percentToMinute(percent))
    }

    $: minutes = reactiveMemoryManager.getLessonTime(practice, lowerLimit, upperLimit)
</script>

{#each minutes as minute, i}
    <div class="{grayscale ? "grayscale" : ""} {hidden ? "hidden" : ""} aria-disabled:pointer-events-none absolute inset-0" aria-disabled={!enabled}>
        <div
            class="absolute top-0 h-full w-[2px] {classList} -translate-x-1/2"
            
            style:left="{minuteToPercent(minute) * 100}%"
        />
        {#if practice.individualMovability !== 0}
            <!-- Draggable! -->
            <TimeSliderDraggable
                pulsing={minute < pulseBefore}
                class={classList}
                percent={minuteToPercent(minute)}
                change={(percent) => changeIndividualPosition(+i, percent)}
            >
                {format(addMinutes(startOfDay(new Date()), minute), "h:mm a")}
            </TimeSliderDraggable>
        {/if}
    </div>
{/each}
